<template>
	<div class="videoModal" v-if="show">
		<div class="mask"></div>
		<img @click="show = false" src="@/assets/image/layout/close.png" class="close" />
		<div class="videobox flex">
			<div class="videoMenu">
				<div class="father-module flex flex-v">
					<div class="title-module flex flex-pack-justify">
						<img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
						<div>监控列表</div>
					</div>
					<div class="searchbar flex flex-align-center">
						<input class="txt flex-1" />
						<img src="@/assets/image/layout/search.png" alt="" />
					</div>
					<div class="menu flex-1">
						<div class="menu-item" v-for="(item, index) in menuList" :key="index">
							<div class="menu-title" v-if="item.biBridgeCameraList.length > 0">
								<img class="menu-icon" src="@/assets/image/layout/line2.png" alt="" srcset="" />
								<span>{{ item.bridgeName }}</span>
							</div>
							<div class="list" v-if="item.biBridgeCameraList.length > 0">
								<div
									 class="menu-sub-item flex flex-align-center"
									 :class="{ active: videoUrl == subitem.cameraUrl }"
									 v-for="(subitem, subindex) in item.biBridgeCameraList"
									 :key="subindex" @click="play(subitem.cameraUrl)">
									<img class="menu-sub-icon" src="@/assets/image/layout/bridge-addr.png" alt="" />
									<span class="flex-1">{{ subitem.cameraName }}</span>
									<div class="num">{{ subitem.num || 1 }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="videoMain flex-1">
				<videoPlayer :videoUrl="videoUrl"></videoPlayer>
			</div>
		</div>
	</div>
</template>

<script>
import videoPlayer from './videoPlayer'
export default {
	data() {
		return {
			show: false,
			curId: 1,
			videoUrl: '',
			menuList: [
				{
					name: '新安江大桥',
					list: [
						{
							name: '东南角01',
							num: 1,
							id: 1
						},
						{
							name: '东南角02',
							num: 1,
							id: 2
						}
					]
				},
				{
					name: '白沙大桥',
					list: [
						{
							name: '东南角01',
							num: 1,
							id: 3
						},
						{
							name: '东南角02',
							num: 1,
							id: 4
						}
					]
				}
			]
		}
	},
	components: { videoPlayer },
	methods: {
		open(list, videoUrl) {
			this.menuList = [...list]
			this.videoUrl = videoUrl
			this.show = true
		},
		play(videoUrl) {
			this.videoUrl = videoUrl
		}
	}
}
</script>

<style scoped lang="scss">
.videoModal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;

	.mask {
		height: 100%;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
	}

	.close {
		position: absolute;
		top: 40px;
		right: 83px;
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.videobox {
		width: 90%;
		position: absolute;
		height: 80%;
		top: 10%;
		left: 5%;

		.videoMenu {
			width: 337px;
			height: 100%;

			.father-module {
				margin: 0;
			}

			.menu {
				margin-left: -22px;
				margin-top: 15px;
				overflow: auto;
				min-height: 0;
				text-align: left;
				color: #fff;
				font-size: 14px;

				.menu-item {
					margin-top: 20px;
				}

				.menu-title {
					line-height: 36px;
					padding-left: 22px;
				}

				.menu-icon {
					width: 14px;
					height: 2px;
					margin-right: 10px;
				}

				.menu-sub-item {
					line-height: 36px;
					margin-top: 25px;
					cursor: pointer;
					padding-left: 22px;

					&.active {
						background: linear-gradient(90deg, #01baff 0%, rgba(1, 93, 128, 0) 100%);
					}
				}

				.num {
					width: 24px;
					height: 24px;
					border-radius: 100%;
					border: 1px solid #fff;
					text-align: center;
					line-height: 24px;
					font-size: 12px;
				}

				.menu-sub-icon {
					width: 25px;
					height: 30px;
					margin-right: 10px;
				}
			}
		}
	}
}

.searchbar {
	width: 290px;
	height: 36px;
	padding: 0 15px;
	box-sizing: border-box;
	margin: 30px auto 0;
	background: url('~@/assets/image/layout/search_bg.png');
	background-size: 100% 100%;

	.txt {
		min-width: 0;
		background: none;
		border: none;
		color: #fff;
	}

	img {
		width: 18px;
		height: 18px;
		cursor: pointer;
	}
}</style>
